import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets/TRECUPERA_imagen_felicidades_CYAN.png'


const _hoisted_1 = { class: "overflow-y-auto px-10" }
const _hoisted_2 = {
  key: 0,
  class: "my-10 text-left"
}
const _hoisted_3 = { class: "grid w-full sm:grid-cols-3 sm:gap-10 mb-10 text-md" }
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-md pt-3 ml-1" }, "Nº de elementos en la página", -1)
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<option value=\"0\" disabled>Seleccione</option><option value=\"10\">10</option><option value=\"20\">20</option><option value=\"30\">30</option><option value=\"50\">50</option>", 5)
const _hoisted_11 = [
  _hoisted_6
]
const _hoisted_12 = { class: "flex flex-col" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "pt-3 ml-1" }, "Ordenar por el campo", -1)
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<option value=\"0\" disabled>Seleccione</option><option value=\"ClientReference\">Factura</option><option value=\"MainParticipant\">Titular</option><option value=\"OriginalAmount\">Total deuda</option><option value=\"DebitBalance\">Por reclamar</option><option value=\"ImportDate\">Reclamación</option><option value=\"Status\">Estado</option>", 7)
const _hoisted_21 = [
  _hoisted_14
]
const _hoisted_22 = { class: "flex flex-col" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "text-md pt-3 ml-1" }, "Ordenar asc/desc", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", {
  value: "0",
  disabled: ""
}, "Seleccione", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", { value: "asc" }, "De menor a mayor", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", { value: "desc" }, "De mayor a menor", -1)
const _hoisted_27 = [
  _hoisted_24,
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = { class: "pb-3 pt-3 px-2" }
const _hoisted_29 = { class: "pb-3 pt-3 px-2" }
const _hoisted_30 = { class: "pb-3 pt-3 px-2 text-right" }
const _hoisted_31 = { class: "pb-3 pt-3 px-2 text-right" }
const _hoisted_32 = { class: "pb-3 pt-3 px-2 text-center" }
const _hoisted_33 = { class: "pb-3 pt-3 px-2" }
const _hoisted_34 = { class: "pb-3 pt-3 px-2" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "hidden xl:inline" }, " Ver detalle ", -1)
const _hoisted_39 = {
  key: 1,
  class: "mt-5 sm:mt-8 xl:mt-20 lg:mt-40"
}
const _hoisted_40 = {
  key: 0,
  class: "w-full grid mb-20 text-center"
}
const _hoisted_41 = /*#__PURE__*/_createStaticVNode("<div class=\"w-full flex pt-8 mb-8\"><img alt=\"logo\" src=\"" + _imports_0 + "\" class=\"w-40 h-40 mx-auto\"></div><div class=\"w-full mb-3 font-bold text-sirit_blue-500\"> ¡Felicidades! ya estamos listos para comenzar </div><div class=\"w-full\"><div class=\"font-bold mb-3\"> Aún no tienes ninguna reclamación subida </div><div>Aprovecha y sube tu primera factura ahora mismo</div></div>", 3)
const _hoisted_44 = [
  _hoisted_41
]
const _hoisted_45 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_fa = _resolveComponent("fa")!
  const _component_sirit_table = _resolveComponent("sirit-table")!
  const _component_comunication_modal = _resolveComponent("comunication-modal")!
  const _component_comment_modal = _resolveComponent("comment-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loading, { loading: _ctx.loading }, null, 8, ["loading"]),
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.loading && _ctx.debtorCases.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _withDirectives(_createElementVNode("select", {
                  onChange: _cache[0] || (_cache[0] = ($event: any) => ($setup.filterDebts())),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.itemsPerPage) = $event)),
                  name: "filterCount",
                  id: "select-filter-count",
                  class: "boder border-black w-full mt-2 hover:outline-none focus:outline-none focus:ring-1 focus:ring-rose-500 rounded-md border-2 px-3 pt-2 pb-3"
                }, _hoisted_11, 544), [
                  [_vModelSelect, _ctx.itemsPerPage]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _withDirectives(_createElementVNode("select", {
                  onChange: _cache[2] || (_cache[2] = ($event: any) => ($setup.filterDebts())),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sortField) = $event)),
                  name: "filterCount",
                  id: "select-filter-count",
                  class: "boder border-black w-full mt-2 hover:outline-none focus:outline-none focus:ring-1 focus:ring-rose-500 rounded-md border-2 px-3 pt-2 pb-3"
                }, _hoisted_21, 544), [
                  [_vModelSelect, _ctx.sortField]
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _withDirectives(_createElementVNode("select", {
                  onChange: _cache[4] || (_cache[4] = ($event: any) => ($setup.filterDebts())),
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sortType) = $event)),
                  name: "filterCount",
                  id: "select-filter-count",
                  class: "boder border-black w-full mt-2 hover:outline-none focus:outline-none focus:ring-1 focus:ring-rose-500 rounded-md border-2 px-3 pt-2 pb-3"
                }, _hoisted_27, 544), [
                  [_vModelSelect, _ctx.sortType]
                ])
              ])
            ]),
            _createVNode(_component_sirit_table, {
              onGetNextPage: $setup.getNextPage,
              onGetPreviousPage: $setup.getPreviousPage,
              headers: _ctx.headers,
              items: _ctx.debtorCases,
              loading: _ctx.loading,
              loadingPage: _ctx.loading,
              pagination: "",
              page: _ctx.page,
              itemsPerPage: _ctx.itemsPerPage,
              maxPages: _ctx.totalPages
            }, {
              default: _withCtx((props) => [
                _createElementVNode("td", _hoisted_28, _toDisplayString(props.item.clientReference), 1),
                _createElementVNode("td", _hoisted_29, _toDisplayString(props.item.mainParticipant), 1),
                _createElementVNode("td", _hoisted_30, _toDisplayString($setup.global.formatAmount(props.item.originalAmount)), 1),
                _createElementVNode("td", _hoisted_31, _toDisplayString($setup.global.formatAmount(props.item.debitBalance)), 1),
                _createElementVNode("td", _hoisted_32, _toDisplayString($setup.global.getFormatDateComplete(
								props.item.importDate,
								3
							)), 1),
                _createElementVNode("td", _hoisted_33, _toDisplayString(props.item.status), 1),
                _createElementVNode("td", _hoisted_34, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (
								$setup.eventOpenModal_(
									props.item.id,
									props.item.lastUpdateDate,
									props.item.debitBalance
								)
							),
                    class: _normalizeClass([`text-${$setup.colors.primary}-500 border-${$setup.colors.primary}-500 hover:bg-${$setup.colors.primary}-600`, "w-full text-md p-1 rounded-md border-2 hover:text-white hover:border-white"])
                  }, " Comunicar cobro ", 10, _hoisted_35)
                ]),
                _createElementVNode("td", {
                  class: _normalizeClass(["pb-3 pt-3 px-2", [$props.type !== '' ? 'text-center' : '']])
                }, [
                  _createElementVNode("span", {
                    onClick: ($event: any) => ($setup.eventOpenModal_comment(props.item)),
                    class: "cursor-pointer mx-1 text-black"
                  }, [
                    _createVNode(_component_fa, { icon: "envelope" })
                  ], 8, _hoisted_36)
                ], 2),
                _createElementVNode("td", {
                  class: _normalizeClass(["pb-3 pt-3 px-2", [$props.type !== '' ? 'text-center' : '']])
                }, [
                  _createElementVNode("span", {
                    onClick: ($event: any) => ($setup.detail(props.item.id)),
                    class: "cursor-pointer mx-1 text-black"
                  }, [
                    _hoisted_38,
                    _createVNode(_component_fa, { icon: "angle-right" })
                  ], 8, _hoisted_37)
                ], 2)
              ]),
              _: 1
            }, 8, ["onGetNextPage", "onGetPreviousPage", "headers", "items", "loading", "loadingPage", "page", "itemsPerPage", "maxPages"])
          ]))
        : (!_ctx.loading && _ctx.debtorCases.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              ($props.idClient === $setup.global.getClietIdSession())
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_44))
                : (_openBlock(), _createElementBlock("div", _hoisted_45, "No hay registros disponibles"))
            ]))
          : _createCommentVNode("", true)
    ]),
    _createVNode(_component_comunication_modal, {
      onOnFireDebts: _cache[6] || (_cache[6] = ($event: any) => ($setup.getDebts())),
      onOnFire: $setup.eventOpenModal_,
      openModal: _ctx.openModal,
      debtorCaseId: _ctx.debtorCaseId,
      lastUpdateDate: _ctx.lastUpdateDate,
      amount: _ctx.amount
    }, null, 8, ["onOnFire", "openModal", "debtorCaseId", "lastUpdateDate", "amount"]),
    (_ctx.openModalComment)
      ? (_openBlock(), _createBlock(_component_comment_modal, {
          key: 0,
          onOnFire: $setup.eventOpenModal_comment,
          openModal: _ctx.openModalComment,
          item: _ctx.itemDeptorcase
        }, null, 8, ["onOnFire", "openModal", "item"]))
      : _createCommentVNode("", true)
  ], 64))
}